module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/code.bb307b80.png";